import { z } from 'zod';
export const HealthResponse = z.object({
    status: z.enum(['ok', 'degraded']),
    version: z.string(),
    client: z.string(),
    /** 'dev' on the test copy of the app (DEV / TEST banner); 'prod' otherwise. */
    instance: z.enum(['prod', 'dev']).default('prod'),
    db: z.enum(['ok', 'down']),
    time: z.string(),
});
//# sourceMappingURL=health.js.map